import isEqual from 'react-fast-compare';
import { useSelector } from 'react-redux';

export default function useOptionsCheck(): boolean {
    return useSelector((ctx) => ctx.platform.type === 'Options', isEqual);
}